(function ($) {
    var CloudZoomCompat = function(element, options) {
        options = (options || {});
        this.element = element;

        try {
            if ( $(element).data('cloudzoom') ) {
                // initialize zoom
                var zoomData = $(element).data('cloudzoom');
                zoomData = '(function() { return {' + zoomData + '} })()';
                // TODO: sanitize the input data somehow (it's not JSON so JSON.parse cannot be used)
                zoomOptions = eval(zoomData);

                if ( zoomOptions.zoomImage ) {
                    var source = $(element).attr('src'),
                        zSource = zoomOptions.zoomImage;

                    this.loadImage(source, zSource);
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    CloudZoomCompat.prototype.loadImage = function(smallImage, largeImage) {
        $(this.element)
            .attr('src', smallImage)
            .attr('data-zoom', largeImage)
            .deltizoom();
    }

    $.fn.CloudZoom = function(options) {
        $(this).each(function() {
            var element = this;
            $(element).data('CloudZoom', new CloudZoomCompat(element, options));
        });
    }
})(jQuery);
